<template>
  <div class="preview">
    <van-tabs v-model="active">
      <van-tab
        :title="'第' + (index + 1) + '份'"
        v-for="(item, index) in adContent"
        :key="index"
      >
        <div class="container">
          <div>
            <div class="first-part">
              <van-cell
                v-if="index === 0"
                title="门店类型"
                :value="item.dealerType === 1 ? '汽修厂' : '专卖店'"
              />
              <van-cell
                v-if="index === 0"
                title="品牌类型"
                :value="productBrand | productBrandFilter"
              />
              <van-cell v-if="index === 0" title="广告类型" value="门头招牌" />
              <van-cell
                title="材质"
                :value="item.materialQuality | materialQuality"
              />
              <div class="example-img">
                <div>版面示例</div>
                <van-image :src="item.pageExample" @click="previewImg">
                  <template v-slot:error>未上传</template>
                </van-image>
              </div>
            </div>
            <div class="second-part">
              <van-cell title="广告长度" :value="item.longs + '米'" />
              <van-cell title="广告长度" :value="item.height + '米'" />
              <van-cell
                title="广告内容"
                :value="item.content.trim() === '' ? '无内容' : item.content"
              />
              <van-cell
                class="scenery"
                title="实景图片"
                :value="item.realSceneImg.length === 0 ? '无上传照片' : ''"
              />
              <van-image
                v-for="(img, indexes) in item.realSceneImg"
                :key="indexes"
                width="100"
                height="100"
                fit="contain"
                :src="$imgPath + img"
                @click="previewImg"
              />
            </div>
          </div>
          <div class="third-part">
            <div>
              此份广告预估费用:
              <span class="price">{{ item.estimateCost1 }}</span
              >元
            </div>
            广告预估总费用: <span class="price">{{ estimateTotalCost }}</span
            >元
          </div>
          <div class="tips">
            注意：系统预估的广告费用可能与广告实际安装的费用存在偏差；
            广告费用核销时，以哈弗公司财务部最终核算的金额为准。
          </div>
          <van-button type="info" to="/agency/editAd">修改</van-button>
        </div>
      </van-tab>
      <van-tab title="协议内容">
        <div class="container adAgreement">
          <div class="first-party">
            <van-cell title="甲方名称" value="广东哈弗石油能源股份有限公司" />
            <van-cell title="乙方(代理商)" :value="partyAName" />
            <van-cell title="丙方(门店)" :value="agreementContent.partyBName" />
            <van-cell
              title="负责人姓名"
              :value="agreementContent.partyBRealName"
            />
            <van-cell
              title="负责人手机号"
              :value="agreementContent.partyBPhone"
            />
            <van-cell
              title="证件类型"
              :value="agreementContent.idType | idType"
            />
            <van-cell title="证件号码" :value="agreementContent.idNo" />
            <van-cell>
              <template #title>
                <span>营业执照</span>
              </template>
              <template #default>
                <van-image
                  width="100"
                  height="100"
                  fit="contain"
                  :src="$imgPath + agreementContent.idNoImage"
                >
                  <template v-slot:error>未上传</template>
                </van-image>
              </template>
            </van-cell>
            <van-cell
              title="广告位置"
              :value="agreementContent.advertAddress"
            />
            <van-cell title="完成时间" :value="agreementContent.finishAt" />
          </div>
          <div class="module-title">丙方义务</div>
          <div class="second-party">
            <div>
              <span>连续经营哈弗润滑油不少于</span>
              <span style="color:red">{{
                agreementContent.minOperationYears
              }}</span>
              <span>年</span>
            </div>
            <div>
              <span>进货哈弗产品总价值不低于</span>
              <span style="color:red">{{
                agreementContent.minPurchaseValue / 10000
              }}</span>
              <span>万元</span>
            </div>
            <div>
              <span>首批进货总价值不低于</span>
              <span style="color:red">{{
                agreementContent.firstPurchaseValue
              }}</span>
              <span>元</span>
            </div>
            <div>
              <span>首批进货最迟截止日期</span>
              <span style="color:red">{{
                agreementContent.firstLatestPurchaseDate
              }}</span>
            </div>
          </div>
          <div class="module-title">广告报销方式</div>
          <div v-for="(item, index) in refundArr" :key="index" class="refund">
            丙方<span style="color:black" v-if="index == 0">首批</span>
            <span style="color:black" v-if="index != 0">再次</span>进货<span
              style="color:black"
              v-if="index != 0"
              >并累计</span
            >满
            <span>
              {{
                item.stockPrice > 10000
                  ? item.stockPrice / 10000 + "万"
                  : item.stockPrice
              }} </span
            >元时,甲方<span style="color:black" v-if="index != 0">再</span>报销
            <span>{{ item.refund }}</span> 元
          </div>
          <div class="tips">
            备注：实际广告报销费用以哈弗公司财务部最终核算的金额为准
          </div>
          <div class="btn">
            <van-button
              class="btn-left"
              color="#ccc"
              to="/agency/ad-agreement-detail"
              >查看协议</van-button
            >
            <van-button type="info" to="/agency/ad-agreement">修改</van-button>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-submit-bar
      :loading="submitStatus"
      button-text="提交申请"
      @submit="onSubmit"
    />
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import wx from "weixin-js-sdk";
import { Dialog } from "vant";
export default {
  data() {
    return {
      active: 0,
      partyAName: JSON.parse(localStorage.getItem("apply")).partyAName,
      productBrand: localStorage.getItem("productBrand"),
      estimateTotalCost: localStorage.getItem("estimateTotalCost"),
      agreementContent: "",
      refundArr: [],
      adContent: [],
      submitStatus: false
    };
  },
  filters: {
    productBrandFilter(type) {
      switch (type) {
        case "1":
          return "原动力";
        case "2":
          return "力猛";
        case "3":
          return "原动力+力猛";
        default:
          break;
      }
    },
    materialQuality(type) {
      switch (type) {
        case 1:
          return "铁架+灯布";
        case 2:
          return "彩钢板+PVC";
        case 3:
          return "铝塑板+PVC字";
        case 4:
          return "铝塑板+平面发光字";
        case 5:
          return "纯灯布";
        default:
          break;
      }
    },
    idType(type) {
      switch (type) {
        case 1:
          return "身份证";
        case 2:
          return "营业执照";
        default:
          return "";
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      let dealData = JSON.parse(localStorage.getItem("apply"));
      this.agreementContent = dealData;
      this.refundArr = JSON.parse(dealData.reimbursementMethod);
      this.adContent = JSON.parse(localStorage.getItem("content"));
      this.adContent.forEach(val => {
        if (val.realSceneImg.length != 0) {
          val.realSceneImg = val.realSceneImg.split(",");
        } else {
          val.realSceneImg = [];
        }
      });
      // console.log(this.agreementContent);
    },
    //预览图片
    previewImg(e) {
      ImagePreview([e.srcElement.src]);
    },
    // 提交
    onSubmit() {
      this.submitStatus = true;
      this.$api
        .adApply(JSON.parse(localStorage.getItem("apply")))
        .then(res => {
          if (res.code === 0) {
            this.submitStatus = false;
            Dialog.alert({
              title: "提示",
              message: "您的广告申请已提交！",
              confirmButtonText: "关闭"
            }).then(() => {
              localStorage.removeItem("content");
              localStorage.removeItem("apply");
              localStorage.removeItem("estimateTotalCost");
              localStorage.removeItem("productBrand");
              localStorage.removeItem("minimum");
              localStorage.removeItem("ratio");
              localStorage.removeItem("allStockPrice");
              wx.closeWindow();
              this.$router.push("/agency/history");
            });
          } else {
            this.submitStatus = false;
            Dialog.alert({
              title: "提示",
              message: "提交失败,请检查",
              confirmButtonText: "关闭"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.submitStatus = false;
          this.$toast("请求超时,请稍后再试");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.preview {
  padding-bottom: 3rem;
  .submit {
    position: fixed;
    bottom: 0;
  }
}

.adAgreement {
  padding-top: 10px;

  .module-title {
    padding: 5px 0;
    background-color: #eaeaea;
  }

  .papers-img {
    padding: 10px 20px;
    text-align: left;
    color: #646566;
    font-size: 14px;
    font-weight: 600;
  }

  .second-party {
    div {
      padding: 10px 20px;
      text-align: left;
      font-size: 14px;
    }

    .scenery:not(:last-child)::after {
      display: none;
    }
  }

  .agreement-detail {
    display: block;
    margin-bottom: 20px;
    font-size: 12px;
  }

  .refund {
    padding: 10px 20px;
    text-align: left;
    font-size: 14px;

    span {
      color: red;
    }
  }

  .tips {
    text-align: left;
    font-size: 14px;
    color: red;
  }

  .btn {
    display: flex;
    padding: 10px 20px;

    .btn-left {
      margin-right: 20px;
    }
  }
}

.van-cell {
  padding: 10px 20px;
  align-items: center;
}

.van-cell__title,
.van-cell__value {
  text-align: left;
}

.container {
  padding-bottom: 20px;

  .first-part {
    border-bottom: 15px solid #eaeaea;

    .example-img {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      font-size: 14px;

      div {
        flex: 1;
        text-align: left;
      }

      van-image {
        flex: 1;
      }
    }

    .van-cell__title {
      text-align: left;
    }

    .van-cell__value {
      text-align: center;
    }
  }

  .second-part {
    border-bottom: 15px solid #eaeaea;
    margin-bottom: 20px;

    .van-cell__title {
      text-align: left;
    }

    .van-cell__value {
      text-align: center;
    }
  }

  .third-part {
    padding: 0 20px;
    margin-bottom: 20px;
    text-align: left;

    .price {
      color: red;
    }
  }

  .tips {
    padding: 20px;
    padding-top: 0;
    font-size: 14px;
    text-align: left;
    color: red;
  }
}
</style>
<style lang="scss">
.scenery:not(:last-child)::after {
  display: none;
}

.preview {
  .van-dialog__message {
    font-size: 20px;
  }
}
</style>
